import { get } from '@/api/request'
import { PaginationResponse, PaginationParams, BResponse } from '@/api/base'

// 产品事例
export interface CommodityDemo {
  id: number
  name: string
  coverPic: string
  description: string
  feedbackPic: string
  createdTime: string
  updatedTime: string
}

// 成果统计数据
export interface AchievementStatistic {
  totalIdentifiedProducts: number
  totalComplaintsHandled: number
  totalPartnerBrands: number
  userSatisfactionRate: number
}

type StatisticItem = {
  totalIdentifiedProducts: number
  totalComplaintsHandled: number
  totalPartnerBrands: number
  userSatisfactionRate: number
}
/**
 * 获取商品样例列表
 */
export const queryCommodityDemoList = (params: PaginationParams = { page: 1, size: 1, orderBy: 'created_time', order: 'desc' }) => {
  return get<PaginationResponse<CommodityDemo>>(' /authenti-guard/v1/api/commodity-demo/list', params)
}

// /api/achievement-statistics/display
export const queryAchievementData = () => {
  return get<StatisticItem>(' /authenti-guard/v1/api/achievement-statistics/display')
}
